const controller = '/manager/dashboard/document'
export default axios => ({
  createLeaseDocument(obj) {
    return axios.post(`${controller}/create-lease-agreement-pdf`, obj)
  },
})
